
<div class="container-code" *ngIf="loaded">
    <div class="container-code-2">
        <script src="assets/monaco/min/vs/loader.js"></script>
        <div *ngIf="code !== initCode" class="generic-buttons-blue-revert">
            <button mat-raised-button (click)="saveCode()">Guardar</button>
        </div>
        <ngx-monaco-editor style="height: 100%" [options]="editorOptions" [(ngModel)]="code"></ngx-monaco-editor>
    </div>
</div>